import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../../lib/utils";

export function Slider({
  "aria-label": ariaLabel,
  className,
  defaultValue = [50],
  max = 100,
  min = 0,
  onValueChange,
  step = 1,
  thumbClassName,
  trackClassName,
  value,
}: {
  "aria-label"?: string;
  className?: string;
  defaultValue?: number[];
  max?: number;
  min?: number;
  onValueChange?: (value: number[]) => void;
  step?: number;
  thumbClassName?: string;
  trackClassName?: string;
  value?: number[];
}) {
  return (
    <SliderPrimitive.Root
      className={cn(
        "relative flex min-h-11 w-full touch-none items-center",
        className,
      )}
      defaultValue={defaultValue}
      max={max}
      min={min}
      onValueChange={onValueChange}
      step={step}
      value={value}
    >
      <SliderPrimitive.Track
        className={cn(
          "relative h-2 flex-1 rounded-full bg-muted",
          trackClassName,
        )}
      >
        <SliderPrimitive.Range className="absolute h-full rounded-full bg-primary" />
      </SliderPrimitive.Track>
      {(value ?? defaultValue).map((_, index) => (
        <SliderPrimitive.Thumb
          key={index}
          aria-label={ariaLabel}
          className={cn(
            "block h-5 w-5 rounded-full border-4 border-background bg-primary shadow-md",
            thumbClassName,
          )}
        />
      ))}
    </SliderPrimitive.Root>
  );
}
